<template>
  <button
    :class="[{ active: isActive }, teamType.toLowerCase()]"
    @click="selectTeamTypeToCreate(teamType)"
    v-text="teamType"
  />
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'ButtonCreateTeam',
  props: {
    teamType: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['teamTypeToCreate']),
    isActive() {
      return this.teamType === this.teamTypeToCreate;
    },
  },
  methods: {
    ...mapMutations(['selectTeamTypeToCreate']),
  },
};
</script>

<style lang="less" scoped>
@import "~@/less/variables.less";
button {
  width: 80px;
  background-color: #fff;
  border: 1px solid #2c3e50;
  & + & {
    margin-left: 10px;
  }
  &:hover, &.active {
    color: #fff;
    border: none;
    &.pm {
      background-color: @pm-color;
    }
    &.ux {
      background-color: @ux-color;
    }
    &.rd {
      background-color: @rd-color;
    }
    &.qa {
      background-color: @qa-color;
    }
    &.pantry {
      background-color: @pantry-color;
    }
    &.meeting {
      background-color: @meeting-color;
    }
  }
}
</style>
